import Vue from 'vue'
import App from './App.vue'
import './assets/theme.css'
import './index.css'
import './assets/design.css'
import router from './router'
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueApexCharts from 'vue-apexcharts';



Vue.use(VueApexCharts)
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('apexchart', VueApexCharts)



import i18n from './i18n';
import './theme';



Vue.config.productionTip = false
// Stock(Highcharts);


Vue.use(Toast);

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
